export const configurationFieldsMapSF = {
  direction: 'in',
  CreatedById: 'createdById',
  CreatedDate: 'createdDate',
  Id: 'id',
  IsDeleted: 'isDeleted',
  LastModifiedById: 'lastModifiedById',
  LastModifiedDate: 'lastModifiedDate',
  LastReferencedDate: 'lastReferencedDate',
  LastViewedDate: 'lastViewedDate',
  Name: 'name',
  OwnerId: 'ownerId',
  SystemModstamp: 'systemModstamp',
  Type__c: 'type',
  Value__c: 'value'
}

export interface Configuration {
  createdById: string
  createdDate: string
  id: string
  isDeleted: boolean
  lastModifiedById: string
  lastModifiedDate: string
  lastReferencedDate: string | null
  lastViewedDate: string | null
  name: string | {
    [langKey: string]: string
  }
  ownerId: string
  systemModstamp: string
  type: string | null
  value: string
}

export interface ConfigurationValue {
  type: string
}
